import { useQuery } from "@tanstack/react-query";

import { axiosGetData } from "@shared/api/clients";
import {
  usePaginatedQuery,
  useUrlPaginatedQuery,
} from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";

import {
  AdminComplexFilters,
  GetAdminComplexDetailResponse,
  ListAdminComplexesResponseItem,
} from "./complexes.types";

const ADMIN_COMPLEXES_ENDPOINT = "v1/admin/complexes";
export const ADMIN_COMPLEXES_QUERY_KEY = ["admin", "complexes"];
const ADMIN_COMPLEXES_FILTER_KEYS: (keyof AdminComplexFilters)[] = [
  "name",
  "fantasyName",
  "cnpj",
  "responsibleName",
  "sortBy",
  "sortOrder",
];

export const useAdminComplexesQuery = (
  params?: PaginatedQueryParams<AdminComplexFilters>,
  options?: { enabled?: boolean },
) => {
  return usePaginatedQuery<
    ListAdminComplexesResponseItem,
    AdminComplexFilters
  >({
    endpoint: ADMIN_COMPLEXES_ENDPOINT,
    queryKeyBase: ADMIN_COMPLEXES_QUERY_KEY,
    params,
    enabled: options?.enabled,
  });
};

export const useAdminComplexesUrlQuery = () => {
  return useUrlPaginatedQuery<
    ListAdminComplexesResponseItem,
    AdminComplexFilters
  >({
    endpoint: ADMIN_COMPLEXES_ENDPOINT,
    queryKeyBase: ADMIN_COMPLEXES_QUERY_KEY,
    filterKeys: ADMIN_COMPLEXES_FILTER_KEYS,
  });
};

export const getAdminComplex = async (
  complexId: string,
): Promise<GetAdminComplexDetailResponse> => {
  return axiosGetData<GetAdminComplexDetailResponse>(
    `${ADMIN_COMPLEXES_ENDPOINT}/${complexId}`,
  );
};

export const useAdminComplexQuery = (
  complexId: string | null | undefined,
) => {
  return useQuery({
    queryKey: [...ADMIN_COMPLEXES_QUERY_KEY, "detail", complexId],
    queryFn: () => getAdminComplex(complexId as string),
    enabled: Boolean(complexId),
    staleTime: 1000 * 30,
    retry: false,
  });
};
